<template>
  <div class="userBoxComp">
    <div v-if="idrcLogin && idrcLogin.token_id"
         class="idrcLogo_wrap">
      <img :alt="`Idrc logo ${usuario.nome}`"
           class="idrcLogo_wrap_img"
           :srcset="idrcLogo"
           src="">
    </div>
    <b-dropdown right
                toggle-class="userBox d-inline-flex justify-content-between align-items-center"
                variant="light">
      <template slot="button-content">
        <div class="userBox_wrap">
          <img :alt="`Imagem do usuário ${usuario.nome}`"
               class="userBox_wrap_img"
               :srcset="usuario.foto_de_perfil_url || userImg"
               src="">
        </div>
        <p class="userBox_content text-truncate"
           :title="usuario.nome">
          {{ usuario.nome }}
        </p>
      </template>

      <div v-if="idrcLogin && idrcLogin.token_id">
        <b-dropdown-item :href="urlPerfil"
                         target="_blank"
                         title="Identificação do Registro Civil do Brasil (idRC)">
          Acessar meus dados
        </b-dropdown-item>
        <b-dropdown-divider />
      </div>
      <b-dropdown-item :to="{ name: 'administracaoSistema' }">
        Administrar Sistema
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout">
        Sair
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import userFallback from '@/assets/icons/user-fallback.svg'
  import login_idrc from '@/assets/icons/logo-idrc-com-mao-com-texto.svg'
  import {mapGetters} from "vuex"
  import store from "@/store"

  export default {
    name: "UserHeaderInfo",
    data () {
      return {
        idrcLogo: login_idrc,
        userImg: userFallback,
        certificadoSelecionado: null,
        certificados: null,
        urlPerfil: null,
      }
    },
    computed: {
      ...mapGetters({
        idrcLogin: 'auth/getUser',
      }),
      usuario () {
        const { usuario } = this.$store.state.auth
        return usuario
      }
    },
    created () {
      if (process.env.NODE_ENV === 'development') {
        this.urlPerfil = 'https://perfilhmlg.idrc.org.br/meus-dados'
      } else {
        this.urlPerfil = 'https://perfil.idrc.org.br/meus-dados'
      }
    },
    methods: {
      async logout () {
        const user = store.getters['auth/getUser']

        await this.$store.dispatch('auth/logoutIDRC', user.user_id).then(async () => {
          this.$store.dispatch('lote/updateLoteRegistrosSelecionados', [])
          await this.$store.dispatch('auth/logout')

          // this.$router.push({ name: 'login' }).then(() => {
          //   location.reload()
          // })
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/_utilities/exports';

  .userBoxComp {
    display: grid;
    justify-items: center;
    padding-top: 0;
  }

  .userBox {
    background-color: transparent;
    border: pxToRem(1) solid;
    border-color: transparent $color-gray-light;
    max-height: pxToRem(50);
    margin: 0 pxToRem(8);
    padding: 0 pxToRem(8) !important;
    width: pxToRem(64);

    &_wrap {
      border-radius: 50%;
      display: inline-block;
      line-height: 0;
      height: pxToRem(32);
      overflow: hidden;
      width: pxToRem(32);

      &_img {
        background-color: $color-gray-light;

        @supports (object-fit: cover) {
          object-fit: cover;
          height: 100%;
        }
        width: 100%;
      }
    }

    &_content {
      color: $color-gray;
      display: none;
      font-size: pxToRem(16);
      margin: 0;
      padding-left: pxToRem(6);
    }

    &:hover,
    &:active {
      background-color: transparent !important;
      border-color: transparent $color-gray-light !important;
    }

    @media(min-width: pxToRem(400)) {
      width: pxToRem(132);

      &_content {
        display: inline-block;
        @include calc(width, '100% - #{pxToRem(40)}', null);
      }
    }

    @media(min-width: pxToRem(568)) {
      margin: 0 pxToRem(12);
      padding: 0 pxToRem(12);
      width: pxToRem(180);
    }

    @media(min-width: pxToRem(1024)) {
      width: pxToRem(192);
    }
  }

  .idrcLogo {
    background-color: transparent;
    border: pxToRem(1) solid;
    border-color: transparent $color-gray-light;
    max-height: pxToRem(50);
    margin: 0 pxToRem(8);
    padding: 0 pxToRem(8);
    width: pxToRem(64);

    &_wrap {
      //border-radius: 50%;
      display: inline-block;
      line-height: 0;
      height: pxToRem(11);
      overflow: hidden;
      width: pxToRem(64);
      transform: scale(2.7);
      transform-origin: center 9px;

      &_img {
        @supports (object-fit: cover) {
          object-fit: contain;
          height: 100%;
        }
        width: 100%;
      }
    }

    &:hover,
    &:active {
      background-color: transparent !important;
      border-color: transparent $color-gray-light !important;
    }

    @media(min-width: pxToRem(400)) {
      width: pxToRem(132);

      &_content {
        display: inline-block;
        @include calc(width, '100% - #{pxToRem(40)}', null);
      }
    }

    @media(min-width: pxToRem(568)) {
      margin: 0 pxToRem(12);
      padding: 0 pxToRem(12);
      width: pxToRem(180);
    }

    @media(min-width: pxToRem(1024)) {
      width: pxToRem(192);
    }
  }
</style>
